import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import RenderDays from './RenderDays';
import RenderDaysHeader from './RenderDaysHeader';
import RenderWeeks from './RenderWeeks';
import { Box } from '@material-ui/core';
import { DateRangeContext } from '../../context/appcontext';
import styles from './layoutStyle';
import PropTypes from 'prop-types';

moment.updateLocale('wm', {
	week: {
		dow: 6,
	},
});

moment.updateLocale('std', {
	week: {
		dow: 0,
	},
});

function Layout({ month, min, max, minWk, maxWk }) {
	const [trackWeekClick, setTrackWeekClick] = useState(0);
	const {
		handleSetDateRange,
		//cbSetDateRange,  INCORRECTLY PASSED HERE
		usrSelection,
		showWk,
		showWalCal,
		singleWkSelEnable,
	} = useContext(DateRangeContext);
	const [calSelection, setCalSelection] = useState({ ...usrSelection });
	const classes = styles();
	const { calContainer, calander, days } = classes;

	useEffect(() => {
		setCalSelection({ ...usrSelection });
	}, [usrSelection]);

	function handleWeekDayHighlight(wk, selWeek) {
		let _selection = {};
		if (trackWeekClick % 2 === 0) {
			_selection = {
				week1: wk,
				week2: wk,
				start: moment(selWeek).startOf('week'),
				end: moment(selWeek).endOf('week'),
			};
		} else {
			_selection = {
				...calSelection,
				week2: wk,
				end: moment(selWeek).endOf('week'),
			};
		}
		// If single selection enabled
		if (singleWkSelEnable) {
			setTrackWeekClick(2);
		} else {
			setTrackWeekClick(trackWeekClick + 1);
		}

		if (_selection.end.isBefore(_selection.start, 'week')) {
			setCalSelection({});
		} else {
			setCalSelection(_selection);
			handleSetDateRange(_selection);
		}
	}

	function handleDaySelection(selDay) {
		let _selection = {};
		if (trackWeekClick % 2 === 0) {
			_selection = {
				start: selDay,
				end: selDay,
			};
		} else {
			_selection = {
				...calSelection,
				end: selDay,
			};
		}
		// If single selection enabled
		if (singleWkSelEnable) {
			setTrackWeekClick(2);
		} else {
			setTrackWeekClick(trackWeekClick + 1);
		}
		if (_selection.start.isAfter(_selection.end)) {
			setCalSelection({});
		} else {
			setCalSelection(_selection);
			handleSetDateRange(_selection);
		}
	}

	return (
		<Box className={calContainer}>
			{month?.map((_m, idx) => {
				return (
					<Box className={calander} key={idx}>
						<Box style={{ display: 'flex' }}>
							<RenderWeeks
								cbWeekHighlight={handleWeekDayHighlight}
								_month={_m}
								calSelection={calSelection}
								showWkSelection={showWk}
								min={min}
								max={max}
								showWalCal={showWalCal}
								minWk={minWk}
								maxWk={maxWk}
							/>
							<Box className={days}>
								<RenderDaysHeader showWalCal={showWalCal} />
								<RenderDays
									_month={_m}
									calSelection={calSelection}
									cbDaySelection={handleDaySelection}
									min={min}
									max={max}
									minWk={minWk}
									maxWk={maxWk}
									showWkSelection={showWk}
								/>
							</Box>
						</Box>
					</Box>
				);
			})}
		</Box>
	);
}

Layout.propTypes = {
	month: PropTypes.array,
	min: PropTypes.object,
	max: PropTypes.object,
	minWk: PropTypes.object,
	maxWk: PropTypes.object,
};

export default Layout;
